// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3o7fL","icon":"SortAdornment_icon__5Ghtn","up":"SortAdornment_up__1w2-c","down":"SortAdornment_down__1LV-1","active":"SortAdornment_active__L91w8"};